import React, {useEffect, useState} from "react";
import { Image, Row, Col, Container } from "react-bootstrap";
import styles from "../css/banner.module.css";
import parse from "html-react-parser";
const Banner = ({sunwestLink2, celligenceLlcLink, pavanLink, angelAiLink}) => {
  return (
    <div className={styles["banner-section"]}>
      <Container className={styles["banner-row-container"]}>
        {/* <Row className={styles["banner-row"]}>
          <Col xl={9} lg={10} md={8} sm={12} className={`px-0 ${styles[""]}`}>
            <div className={styles["logo-div"]}>
              <a href="https://www.swmc.com/" target="_self">
                <Image
                  className={styles["swmc-logo"]}
                  src={`${process.env.REACT_APP_CDN}images/logo_mobile.svg`}
                  fluid
                  alt="swmc-logo"
                  width={"400px"}
                  height={"100px"}
                  fetchpriority="high"
                />
              </a>
            </div>
          </Col>
        </Row> */}
        <Row className={styles["info-row"]}>
          <Col
            xl={7}
            lg={8}
            md={8}
            sm={12}
            xs={12}
            className={styles["content-col"]}
          >
            <div className={`${styles["ceo-info"]} text-align-left`}>
              <p>{pavanLink ? parse(pavanLink) : "Pavan Agarwal"}</p>
              <p className={styles["CEOtext"]}>Founder/CEO of {parse(celligenceLlcLink)}<br/>Creator of {parse(angelAiLink)}<br/>CEO of {parse(sunwestLink2)}, nmls 3277</p>
            </div>
            <Image
              className={`${styles["circular-stripe"]} ${styles["circular-stripe-blue"]}`}
              src={`${process.env.REACT_APP_CDN}images/circular_stripes_blue.svg`}
              fluid
              alt="circular-stripe blue icon"
              width={"50px"}
              height={"70px"}
            />
          </Col>
          <Col
            xl={5}
            lg={4}
            md={4}
            sm={12}
            xs={12}
            className={styles["ceo-img-col"]}
          >
            <div>
              <div className={styles["SocialIcons"]}>
                <div className={styles["insta"]}>
                  <a
                    href="https://www.instagram.com/pavanagarwal_ai/"
                    target="_blank"
                    className={styles["iconPavan"]}

                  >
                    <Image
                      className={`${styles["InstaPavan"]}`}
                      src={`${process.env.REACT_APP_CDN}images/Insta_pavan.png`}
                      fluid
                      alt="Pavan_Instagram"
                      width={"38px"}
                    />
                  </a>
                </div>
                <a
                  href="https://www.youtube.com/user/SunWestMortgageCo/"
                  target="_blank"
                  className={styles["iconPavan"]}
                >
                  <Image
                    className={`${styles["YoutubePavan"]}`}
                    src={`${process.env.REACT_APP_CDN}images/youtube_pavan.png`}
                    fluid
                    alt="Pavan_YouTube"
                    width={"38px"}
                  />
                </a>
                <a
                  href="https://twitter.com/PavanCelligence"
                  target="_blank"
                  className={styles["iconPavan"]}
                >
                  <Image
                    className={`${styles["twitterPavan"]}`}
                    src={`${process.env.REACT_APP_CDN}images/twitter_pavan.png`}
                    fluid
                    alt="Pavan_Twitter"
                    width={"38px"}
                  />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100056999677087"
                  target="_blank"
                  className={styles["iconPavan"]}
                >
                  <Image
                    className={`${styles["facebookPavan"]}`}
                    src={`${process.env.REACT_APP_CDN}images/facebook_pavan.png`}
                    fluid
                    alt="Pavan_Facebook"
                    width={"38px"}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/in/pavan-agarwal-sunwest-celligence/"
                  target="_blank"
                  className={styles["iconPavan"]}
                >
                  <Image
                    className={`${styles["LinkdnPavan"]}`}
                    src={`${process.env.REACT_APP_CDN}images/linkdn_pavan.png`}
                    fluid
                    alt="Pavan_Linkedin"
                    width={"38px"}
                  />
                </a>
              </div>
              <Image
                className={styles["ceo-img"]}
                src={`${process.env.REACT_APP_CDN}images/Pavan_photo.png`}
                fluid
                alt="ceo image"
                width={"200px"}
                height={"200px"}
                fetchpriority="high"
                title="ceo image"
              />
            </div>
          </Col>
        </Row>
      </Container>
      <div className={styles["banner-img"]} />
      <Image
        className={`${styles["dot-matrix"]} ${styles["dot-matrix-b-1"]}`}
        src={`${process.env.REACT_APP_CDN}images/dot_matrix_2.svg`}
        fluid
        alt="dot-matrix icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["dot-matrix"]} ${styles["dot-matrix-b-2"]}`}
        src={`${process.env.REACT_APP_CDN}images/dot_matrix_2.svg`}
        fluid
        alt="dot-matrix icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["circular-stripe"]} ${styles["circular-stripe-img-1"]}`}
        src={`${process.env.REACT_APP_CDN}images/circular_stripes.svg`}
        fluid
        alt="circular-stripe icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["circular-stripe"]} ${styles["circular-stripe-img-2"]}`}
        src={`${process.env.REACT_APP_CDN}images/circular_stripes.svg`}
        fluid
        alt="circular-stripe icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["circular-stripe"]} ${styles["circular-stripe-img-3"]}`}
        src={`${process.env.REACT_APP_CDN}images/circular_stripes.svg`}
        fluid
        alt="circular-stripe icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["circular-stripe"]} ${styles["circular-stripe-img-4"]}`}
        src={`${process.env.REACT_APP_CDN}images/circular_stripes.svg`}
        fluid
        alt="circular-stripe icon"
        width={"50px"}
        height={"70px"}
      />
      
    </div>
  );
};

export default Banner;
